import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";

import reducers from "./pages/lhn/reducers";
import ServiceUrl from "./pages/lhn/factories/serviceUrl"; // eslint-disable-

let composeEnhancers = compose;
if (typeof DEVELOPMENT !== "undefined") {
  /* eslint-disable */
  composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;
  /* eslint-enable */
}

export default (serverSide = false, initialState) => {
  const link = createHttpLink({
    uri: ServiceUrl.getServiceUrl("service.cosmo"),
    credentials: "include"
  });

  const cache = new InMemoryCache({});

  const client = new ApolloClient({
    link,
    cache,
    queryDeduplication: true,
    ssrMode: serverSide
  });

  const middlewares = [thunk];
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  const store = createStore(combineReducers(reducers), initialState, enhancer);

  if (module.hot) {
    module.hot.accept("./pages/lhn/reducers", () =>
      System.import("./pages/lhn/reducers").then((reducerModule) =>
        store.replaceReducer(
          combineReducers({
            ...reducerModule.default,
            apollo: client.reducer()
          })
        )
      )
    );
  }

  return { store, client };
};
